import React from 'react'
import { Outlet } from 'react-router-dom'
import logo from '../assets/images/nettyWorth.png'
import DynamicProvider from '../providers/DynamicProvider'
import { Toaster } from 'react-hot-toast'

const LoginLayout: React.FC = () => {
  return (
    <DynamicProvider>
      <Toaster />
      <div className='flex-col w-full h-screen flex md:flex-row bg-primary '>
        <div className='w-full justify-center h-full flex items-center md:pl-16 md:justify-start lg:pl-0 lg:justify-center'>
          <img src={logo} alt='logo' className='absolute top-[5%] left-[10%] w-[120px] invert' />
          <div className='flex-col flex md:flex-row '>
            <div className='flex-row-reverse w-full h-auto pt-9 pb-[26px] items-center md:w-[127px] bg-primary flex justify-center rounded md:rounded-none md:rounded-bl-lg md:rounded-tl-lg md:flex-col'>
              <span className='text-primary text-base leading-7 font-semibold md:-rotate-90 h-[20%] flex items-center'>
                Login
              </span>
              <div className='w-0 h-0 md:w-[2px] md:h-[80%] bg-grey-blue'></div>
            </div>
            <div className='h-full w-full'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </DynamicProvider>
  )
}

export default LoginLayout
